// assets/delivery-assured.js

class DeliveryAssured {
  constructor() {
    this.bindEvents();
    this.initializeToggleState();
  }

  bindEvents() {
    document.addEventListener("change", this.handleToggleChange.bind(this));
    document.addEventListener(
      "cart:refresh",
      this.initializeToggleState.bind(this)
    );
  }

  handleToggleChange(event) {
    if (!event.target.matches("#deliveryAssuredToggle")) return;

    const toggle = event.target;
    const variantId = toggle.dataset.variantId;

    if (toggle.checked) {
      this.addDeliveryAssuredToCart(variantId);
    } else {
      this.removeDeliveryAssuredFromCart(variantId);
    }
  }

  addDeliveryAssuredToCart(variantId) {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        this.updateCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  removeDeliveryAssuredFromCart(variantId) {
    const formData = {
      updates: {
        [variantId]: 0,
      },
    };

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        this.updateCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  updateCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  }

  initializeToggleState() {
    const toggle = document.getElementById("deliveryAssuredToggle");
    if (!toggle) return;

    const variantId = toggle.dataset.variantId;

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const isInCart = cart.items.some(
          (item) => item.variant_id.toString() === variantId
        );
        console.log("DEBUG: isInCart", isInCart, variantId, cart.items)
        toggle.checked = isInCart;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

// Initialize the DeliveryAssured functionality
document.addEventListener("DOMContentLoaded", () => {
  new DeliveryAssured();
});
